import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';
import {
  TrackContactCreationFilters,
  GetTrackContactCreationResponse,
} from '../../types/trackContactCreation/trackContactCreation.types';

const SERVER_URL = API_CONFIG.SERVER_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: SERVER_URL,
});

// Add request interceptor to include token in headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Get track contact creation with pagination
export const getTrackContactCreation = async (
  filters: TrackContactCreationFilters = {}
): Promise<GetTrackContactCreationResponse> => {
  try {
    const params = new URLSearchParams();

    if (filters.page !== undefined)
      params.append('page', filters.page.toString());
    if (filters.limit !== undefined)
      params.append('limit', filters.limit.toString());

    const response = await api.get(`/track-contact-creation/?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching track contact creation:', error);
    throw error;
  }
};

export default api;
